import React, { Component } from 'react';
import styles from './styles.module.scss';
import { UserStore, RootStore } from 'AppClient/stores';
import { inject, observer } from 'mobx-react';
import { ThemeContext } from 'app-themes';
import classNames from 'classnames';
import { CCBrand } from 'app-types';
import { padStartTwoSymbolsZero } from 'utils/utils';

interface Props {
	userStore?: UserStore;
}

@inject(({ userStore }: RootStore) => ({
	userStore,
}))
@observer
export class CreditCardsSection extends Component<Props> {
	static contextType = ThemeContext;

	render() {
		const { userInfo, sortedCreditCards } = this.props.userStore!;

		const theme = this.context;
		if (userInfo === null) {
			return userInfo;
		}
		return (
			<div
				className={classNames(styles.creditCardsWrap, {
					[styles[`creditCardsWrap-${theme}`]]: theme !== '',
				})}
			>
				<div className={styles.billingDetailsHeader}>Credit cards</div>
				{sortedCreditCards.length === 0 && (
					<div className={styles.noCards}>No cards yet</div>
				)}
				{sortedCreditCards.map((item, index) => (
					<div
						className={classNames(styles.creditCard, {
							[styles.creditCardDefault]:
								index === 0 && !item.isExpired && !item.isDeleted,
							[styles.creditCardExpired]: item.isExpired,
							[styles.creditCardDeleted]: item.isDeleted,
						})}
						key={item.paymentMethodId}
					>
						{index === 0 && !item.isExpired && !item.isDeleted && (
							<div className={styles.creditCardTitle}>Default credit card</div>
						)}
						<div className={styles.creditCardNumber}>
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDot} />
							<span className={styles.creditCardDigits}>{item.lastFourDigits}</span>
						</div>
						<div className={styles.creditCardExpiresDate}>{`${padStartTwoSymbolsZero(
							item.expirationMonth
						)}/${item.expirationYear}`}</div>
						<div className={styles.creditCardFooter}>
							<div
								className={classNames(styles.creditCardLogo, {
									[styles.creditCardLogoVisa]: item.brand === CCBrand.visa,
									[styles.creditCardLogoMasterCard]:
										item.brand === CCBrand.masterCard,
									[styles.creditCardLogoAmex]:
										item.brand === CCBrand.americanExpress,
									[styles.creditCardLogoDiscover]:
										item.brand === CCBrand.discover,
									[styles.creditCardLogoDiners]:
										item.brand === CCBrand.dinersClub,
									[styles.creditCardLogoJcb]: item.brand === CCBrand.jcb,
									[styles.creditCardLogoUnionpay]:
										item.brand === CCBrand.unionPay,
								})}
							/>
						</div>
					</div>
				))}
			</div>
		);
	}
}

export default CreditCardsSection;
